const $popupBtn = $('.js-find-store-btn');

if ($popupBtn.length > 0 && $popupBtn.data('api').length > 0) {
  const $body = $('body');
  const $popup = $('.js-popup-store');
  const $closeBtn = $popup.find('.popup-store__close');
  const $productSelectSku = $('#product-select');
  const $sizeSelector = $('.single-option-selector');
  const $seachValue = $('.js-popup-store-search');
  const $popupBody = $('.js-popup-store-body');
  const $search = $('.popup-store__search');
  const storeApi = $popupBtn.data('api');
  const storesDataFromCustomizer = JSON.parse($('.js-stores-data').text());
  const popupStoresTemplate = $('#popup-stores-template').html();
  const productTags = $popupBtn.data('tags');
  const storesRegion = $('.js-stores-region').text();
  const storesErrorMessage = $('.js-stores-error-message').text();
  const $storesErrorMessagePlaceholder = $('.js-error-message-placeholder');
  $storesErrorMessagePlaceholder.text(storesErrorMessage)

  /**
   * Toggle popup
   * 
   * @param  {Jquery Element} $element
   * @param  {String} className
   * @return {Void}
   */
  const togglePopup = ($element, className) => {
    $element.toggleClass(className);
  }
  
  /**
   * Get product details
   * 
   * @return {Object}
   */
  const getProductDetails = () => {
    let productDetails = $($productSelectSku.children("option:selected")).data('sku');

    if (String(productDetails).includes('/')) {
      productDetails = productDetails.split('/');

      return {
        "product": productDetails[0],
        "fit": productDetails[1].toUpperCase(),
        "size": productDetails[2]
      }
    }

    return {
      "product": productDetails,
      "fit": "",
      "size": ""
    }
  }
  
  /**
   * Get stock
   * 
   * @param  {String} quantity
   * @return {String}
   */
  const getStock = (quantity) => {
    const number = Number(quantity);
  
    if (number < 1) {
      return 'Out of Stock';
    }
  
    if (number < 3) {
      return 'Low Stock';
    }
  
    if (number >= 3) {
      return 'In Stock';
    }
  }
  
  /**
   * Build body items
   * 
   * @param  {Object} quantity
   * @return {String}
   */
  const buildBodyItems = (extractedData) => {
    let html = '';
  
    extractedData.forEach(store => {
      let newItem = popupStoresTemplate;
      const currentCustomizerStoreObject = storesDataFromCustomizer.filter(item => item.store === store.store)[0];
      const currentExtractData = extractedData.filter(item => item.store === currentCustomizerStoreObject.store)[0];
      
      newItem = newItem.replace(/placeholderCountry/g, currentCustomizerStoreObject.region);
      newItem = newItem.replace(/placeholderStore/g, currentCustomizerStoreObject.name);
      newItem = newItem.replace(/placeholderStock/g, getStock(currentExtractData.quantity));
      newItem = newItem.replace(/placeholderUrlStore/g, currentCustomizerStoreObject.url);
      newItem = newItem.replace(/placeholderPhoneNumber/g, currentCustomizerStoreObject.phone);
  
      html = html + newItem;
    })
  
    return html;
  }
  
  /**
   * Build Search
   * 
   * @param  {Number} sizeValue
   * @return {Void}
   */
  const buildSearch = (sizeValue) => {
    let productTagsSearch = '';
    
    if (productTags.replace(',', '')) {
      productTagsSearch = productTags.split(',');
      const name = productTagsSearch[0].trim() ? `${productTagsSearch[0].trim()}` : '';
      const color = productTagsSearch[2].trim() ? `, ${productTagsSearch[2].trim()}` : '';
      const material = productTagsSearch[1].trim() ? ` ${productTagsSearch[1].trim()}` : '';
      const size = sizeValue ? `, ${sizeValue}` : '';
      $seachValue.text(`${name}${color}${material}${size}`);
      $search.show();
    } else {
      $search.hide();
    }
  }
  
  /**
   * Close popup
   * 
   * @return {Void}
   */
  const closePopup = () => {
    $body.removeClass('overflow-hidden')
    $popup.removeClass('is-active')
    $popup.removeClass('is-loaded')
    $popup.removeClass('is-error')
  }
  
  $closeBtn.on('click', function() {
    closePopup();
  })
  
  $popupBtn.on('click', function(event) {
    event.preventDefault();
    
    togglePopup($body, 'overflow-hidden');
    togglePopup($popup, 'is-active');

    $.post(storeApi, getProductDetails(), function(data, status) {
      if (data) {
        const extractedData = data.filter(store => {
          const currentCustomizerStore = storesDataFromCustomizer.filter(storeCustomizer => {
            return storeCustomizer.store === store.stockLevel.Store
          })[0];
          
          if (currentCustomizerStore) {
            return currentCustomizerStore.region === storesRegion;
          }
  
          return false;
        }).map(store => {
          return {
            store: store.stockLevel.Store,
            quantity: store.stockLevel.Quantity
          }
        })
    
        if (status == 'success' && extractedData.length > 0) {
          buildSearch($sizeSelector.children("option:selected").val());
          $popupBody.html(buildBodyItems(extractedData));
          togglePopup($popup, 'is-loaded');
          return;
        }
      } else {
        $popup.addClass('is-loaded')
        $popup.addClass('is-error')
      }
    })
    .fail(function(xhr, status, error) {
      $popup.addClass('is-loaded')
      $popup.addClass('is-error')
    });
  })
}
